export enum FormState {
    Error,
    isNew,
    isEdit
  }
